/** Preset avatars (ids match the server allow-list in services/users.ts). No user uploads: nothing to moderate. */
export const AVATAR_EMOJI: Record<string, string> = {
  snake: '🐍', dragon: '🐉', fox: '🦊', owl: '🦉', cat: '🐱', robot: '🤖', alien: '👽', ninja: '🥷', wizard: '🧙', astronaut: '🧑‍🚀',
};
export const AVATAR_IDS = Object.keys(AVATAR_EMOJI);
